import PropTypes from "prop-types";
import SeccionWrapper from "../SeccionWrapper";
import StepAntecedentes from "../../FormularioPropuestaV2/steps/StepAntecedentes";

const SeccionAntecedentes = ({
  formik,
  camposIA,
  desmarcarCampoIA,
  faltantes,
}) => (
  <SeccionWrapper
    id="seccion-antecedentes"
    numero={3}
    titulo="Antecedentes"
    faltantes={faltantes}
  >
    <StepAntecedentes
      formik={formik}
      camposIA={camposIA}
      desmarcarCampoIA={desmarcarCampoIA}
    />
  </SeccionWrapper>
);

SeccionAntecedentes.propTypes = {
  formik: PropTypes.object.isRequired,
  camposIA: PropTypes.instanceOf(Set),
  desmarcarCampoIA: PropTypes.func,
  faltantes: PropTypes.arrayOf(PropTypes.string),
};

export default SeccionAntecedentes;
